module.exports = __webpack_public_path__ + "img/chevy-cruze3.66583d58.jpg";